import { render, staticRenderFns } from "./RegisterEditAccount.vue?vue&type=template&id=6c09c8e9&scoped=true&"
import script from "./RegisterEditAccount.vue?vue&type=script&lang=js&"
export * from "./RegisterEditAccount.vue?vue&type=script&lang=js&"
import style0 from "./RegisterEditAccount.vue?vue&type=style&index=0&id=6c09c8e9&scoped=true&lang=css&"
import style1 from "./RegisterEditAccount.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c09c8e9",
  null
  
)

export default component.exports